

export const types = {

    authStartLogin: '[Auth] Start login',
    authChecking: '[Auth] Checking login state',
    authCheckingFinish: '[Auth] Checking finish login state',
    authLogin: '[Auth] Login',
    authStartRegister: '[Auth] Start register',
    authStartTokenRenew: '[Auth] Start token renew',
    authLogout: '[Auth] Logout',


    inventSetActiveItem: '[Invent] Set active item',
    inventClearActiveEvent: '[Invent] Clear active event',
    inventSetCategories: '[Invent] Set category',
    inventSetActiveCategory: '[Invent] Set active category',
    inventCreateItem: '[Invent] Create item',
    inventSetItem: '[Invent] Set item',
    inventSetImagesResults: '[Invent] Set images results',
    inventSetActiveImage: '[Invent] Set active image',


    uiCloseNavbar: '[UI] Close navbar',
    uiToggleNavbar: '[UI] Toggle navbar',
    uiToggleSelectImage: '[UI] Toggle select image',
    uiShowSpinner: '[UI] Show spinner',
    uiHideSpinner: '[UI] Hide spinner',
}